module.exports = __webpack_public_path__ + "assets/img/two.4aa93b18.png";